export enum TVA {
    TVA5 = 5.5,
    TVA10 = 10,
    TVA20 = 20,
}

export const TVAs: number[] = [TVA.TVA5, TVA.TVA10, TVA.TVA20];
